import React from 'react'
import styles from './Gallery.module.css'
import {
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  galleryItem1,
  galleryItem2,
  galleryItem3,
  galleryItem4,
} from '../../../Assets/Images/LandingPage/Gallery/Gallery'
import useInstagramFeed from '../../../Hooks/useInstagramFeed'

const Gallery = () => {
  const { feed, loading, error } = useInstagramFeed();

  // Fallback static images
  const staticGalleryImages = [
    {
      src: gallery2,
      href: 'https://www.instagram.com/reel/DR0s9fsjKL7/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
    },
    {
      src: gallery3,
      href: 'https://www.instagram.com/reel/DTTAJCJkX2X/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==https://www.instagram.com/reel/DTTAJCJkX2X/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
    },
    {
      src: gallery4,
      href: 'https://www.instagram.com/reel/DUHaNfHEn03/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
    },
  ]

  // Use feed if available, otherwise static. 
  // We need 4 images total (1 main + 3 small).
  // If feed has < 4 items, we might need a mix or just fallback.
  // For now, if feed has at least 1 item, we try to use it.

  const showDynamic = !loading && !error && feed.length > 0;

  const mainImage = showDynamic && feed[0] ? (feed[0].media_type === 'VIDEO' ? feed[0].thumbnail_url : feed[0].media_url) : gallery1;
  const mainLink = showDynamic && feed[0] ? feed[0].permalink : 'https://www.instagram.com/reel/DOgzbNKEmef/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==';

  const smallImages = showDynamic
    ? feed.slice(1, 4).map(post => ({
      src: post.media_type === 'VIDEO' ? post.thumbnail_url : post.media_url,
      href: post.permalink
    }))
    : staticGalleryImages;

  return (
    <div className={styles.gallery}>
      <div className={`${'customContainer'} ${styles.gallery_wrap}`}>
        <div className={styles.gallery_wrap1}>
          <a
            href={mainLink}
            target={'blank'}
            className={styles.gallery_wrap1__main}
          >
            <img src={mainImage} alt="Instagram Main" style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
          </a>
          <div className={styles.gallery_wrap1__block}>
            {smallImages.map((item, index) => (
              <a
                href={item.href}
                key={index}
                target={'blank'}
                className={styles.gallery_wrap1__second}
              >
                <img src={item.src} alt={`Instagram ${index + 1}`} style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
              </a>
            ))}
          </div>
        </div>
        <div className={styles.gallery_wrap2}>
          <h2 className={styles.gallery_wrap2__title}>
            Follow our journey on{' '}
            <a
              target={'blank'}
              href="https://www.instagram.com/xleum.construction?igsh=MXh1M2QxNTI0M3NvNA%3D%3D"
            >
              Instagram!
            </a>
          </h2>
          <p className={styles.gallery_wrap2__desc}>
            See beautiful things come together with behind-the-scenes, project
            highlights, and updates on our latest work. Get inspired with the
            quality and creativity we bring to every project.
          </p>
        </div>
        <div className={styles.gallery_wrap2__wrapper}>
          <img
            src={galleryItem1}
            alt=""
            className={styles.gallery_wrap2__img1}
          />
          <div className={styles.gallery_wrap2__item}>
            <img
              src={galleryItem2}
              alt=""
              className={styles.gallery_wrap2__item_img}
            />
            <img
              src={galleryItem3}
              alt=""
              className={styles.gallery_wrap2__item_img}
            />
          </div>
          <img
            src={galleryItem4}
            alt=""
            className={styles.gallery_wrap2__img2}
          />
        </div>
      </div>
    </div>
  )
}

export default Gallery
